import { render, staticRenderFns } from "./SnsSignUp.vue?vue&type=template&id=f60a438a&"
import script from "./SnsSignUp.vue?vue&type=script&lang=js&"
export * from "./SnsSignUp.vue?vue&type=script&lang=js&"
import style0 from "./SnsSignUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports